import { FormControl, MenuItem } from '@mui/material';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import usePropertyRequestsStore from 'store/propertyRequestsStore';
import useUserStore from 'store/useUserStore';

const sortMappings: Record<string, { sortBy: string; sortOrder: 'ASC' | 'DESC' } | null> = {
    'Budget (High to Low)': { sortBy: 'maxBudget', sortOrder: 'DESC' },
    'Budget (Low to High)': { sortBy: 'minBudget', sortOrder: 'ASC' },
    'Urgency (Soonest First)': { sortBy: 'urgency', sortOrder: 'ASC' },
    'Urgency (Latest First)': { sortBy: 'urgency', sortOrder: 'DESC' },
    'Bedrooms (Least to Most)': { sortBy: 'minBedrooms', sortOrder: 'ASC' },
    'Bedrooms (Most to Least)': { sortBy: 'maxBedrooms', sortOrder: 'DESC' },
    Latest: { sortBy: 'createdAt', sortOrder: 'DESC' },
};

export default function RequestDropdown() {
    const { selectedSortOption, setSelectedSortOption, setPropertyRequestQueryFilter } = usePropertyRequestsStore();
    const { getUserPlan } = useUserStore();
    const userPlan = getUserPlan();

    // Hide sorting for free plan users
    if (userPlan.title === 'Free') {
        return null;
    }

    const options = [
        'Latest',
        'Budget (High to Low)',
        'Budget (Low to High)',
        'Urgency (Soonest First)',
        'Urgency (Latest First)',
        'Bedrooms (Least to Most)',
        'Bedrooms (Most to Least)',
    ];

    const handleChange = (event: SelectChangeEvent) => {
        const selectedOption = event.target.value;
        setSelectedSortOption(selectedOption);

        setPropertyRequestQueryFilter({
            sortBy: sortMappings[event.target.value]?.sortBy,
            sortOrder: sortMappings[selectedOption]?.sortOrder,
        });
    };

    return (
        <FormControl size="small" className="bg-white/80 md:w-[200px] rounded-lg">
            <Select value={selectedSortOption} onChange={handleChange} displayEmpty renderValue={(selected) => selected}>
                {options.map((option) => (
                    <MenuItem key={option} value={option}>
                        {option}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
